export class MeasurementTool {
  id: number;

  internalTool: any;

  active = false;

  mapId: number;

  constructor(id: number, internalTool: any, active: boolean, mapId: number) {
    this.id = id;
    this.internalTool = internalTool;
    this.active = active;
    this.mapId = mapId;
  }

  activate(): void {
    this.active = true;
    this.internalTool.activate();
  }

  deactivate(): void {
    this.active = false;
    this.internalTool.deactivate();
  }

  tooltipVisibility(visible: boolean) {
    this.internalTool.changeTooltipsVisibility(visible);
  }

  enableEdit(coverage = null) {
    this.internalTool.enableEdit(coverage);
  }

  disableEdit() {
    this.internalTool.disableEdit();
  }

  getColor(): string {
    return this.internalTool.getColor();
  }

  setColor(colorHexCode: string) {
    this.internalTool.setColor(colorHexCode);
  }

  cancel() {
    this.internalTool.cancel();
  }

  toggleMeasurementType(type: number) {
    this.internalTool.toggleMeasurementType(type);
  }
}
